import { DateTime, Interval } from 'luxon'
import { WorkHourRule, WorkWeek } from '../../api/types'

const days = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const

function formatSchedule(rules: WorkHourRule[]) {
  return rules
    .sort(
      (a, b) =>
        DateTime.fromISO(a.from).toMillis() -
        DateTime.fromISO(b.from).toMillis()
    )
    .map((_) => Interval.fromISO(`${_.from}/${_.to}`).toFormat('hh a'))
    .join(', ')
}

export function getSchedule(workWeek: WorkWeek) {
  const date = DateTime.now()
  const schedule = workWeek[days[date.weekday - 1]]
  const has_next = schedule
    .sort(
      (a, b) =>
        DateTime.fromISO(a.from).toMillis() -
        DateTime.fromISO(b.from).toMillis()
    )
    .some((_) => date.hour <= Number(_.from))

  const has_current = schedule
    .map((_) => {
      const from = DateTime.fromISO(_.from)
      const to = DateTime.fromISO(_.to)

      return _.from > _.to
        ? Interval.fromDateTimes(from, to.plus({ day: 1 }))
        : Interval.fromDateTimes(from, to)
    })
    .some((_) => _.contains(date))

  const today = has_next || has_current

  if (schedule && today)
    return {
      type: 'today',
      day: days[date.weekday - 1],
      schedule: formatSchedule(schedule),
      open: has_current,
    }

  const tomorrow = days[date.weekday % days.length]
  const tomorrowSchedule = workWeek[tomorrow]
  if (tomorrowSchedule && tomorrowSchedule.length)
    return {
      open: false,
      day: tomorrow,
      type: 'tomorrow',
      schedule: formatSchedule(tomorrowSchedule),
    }

  let index = date.weekday
  while (index !== date.weekday - 1) {
    const day = days[index % days.length]
    const rules = workWeek[day]

    if (rules && rules.length) {
      return {
        day,
        open: false,
        type: 'other',
        schedule: formatSchedule(rules),
      }
    }

    index = (index + 1) % days.length
  }

  return { open: false }
}
